import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, Package, Mail, Flame } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/shop/wicks', label: 'B.B. Wicks' },
];

const FOOTER_LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/shipping', label: 'Shipping' },
  { to: '/faq', label: 'FAQ' },
];

function WicksSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sessionId) {
      fetchOrderDetails();
    } else {
      setLoading(false);
    }
  }, [sessionId]);

  const fetchOrderDetails = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/wicks/checkout/status/${sessionId}`);
      setOrderDetails(response.data);
    } catch (error) {
      console.error('Error fetching order details:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="substack-site">
      {/* Header */}
      <Header navItems={NAV_ITEMS} />

      {/* Success Content */}
      <main className="order-success-page">
        <div className="success-content">
          {loading ? (
            <div className="loading-screen">
              <div className="loading-spinner"></div>
            </div>
          ) : (
            <>
              <div className="success-icon">
                <CheckCircle size={80} color="#28a745" strokeWidth={1.5} />
              </div>
              
              <h1>Thank You for Your Order!</h1>
              <p className="success-message">
                Your B.B. Wicks candle order has been placed successfully.
              </p>

              {orderDetails?.order && (
                <p className="order-number">
                  Order #{orderDetails.order.order_number}
                </p>
              )}

              <div className="order-info-cards">
                <div className="info-card">
                  <Flame size={32} />
                  <h3>Hand-Poured with Care</h3>
                  <p>Each candle is hand-poured in the Outer Banks with premium ingredients.</p>
                </div>
                <div className="info-card">
                  <Package size={32} />
                  <h3>Shipping Soon</h3>
                  <p>Your order will be carefully packaged and shipped within 1-3 business days.</p>
                </div>
                <div className="info-card">
                  <Mail size={32} />
                  <h3>Confirmation Sent</h3>
                  <p>A confirmation email has been sent to {orderDetails?.customer_email || 'your email'}.</p>
                </div>
              </div>

              <div className="success-actions">
                <Link to="/shop/wicks" className="btn btn-primary">
                  Shop More Candles
                </Link>
                <Link to="/" className="btn btn-secondary">
                  Back to Home
                </Link>
              </div>
            </>
          )}
        </div>
      </main>

      {/* Footer */}
      <Footer showLogo={false} legalLinks={FOOTER_LEGAL_LINKS} />
    </div>
  );
}

export default WicksSuccess;
